/* global ROOT_URL */

import { combineReducers } from "redux";
import { reducer as formReducer } from "redux-form";

import { FETCH_USER_SUCCESS, LOGOUT_USER_REQUEST } from "actions/loginActions";
import { intlReducer as intl } from "../i18n/ReduxIntl";
import benefitsDocuments from "./documentsReducer";
import benefitsSurvey from "./benefitsSurveyReducer";
import benefits from "./benefitsReducer";
import newuiuxBenefits from "./benefitStatementReducer";
import dependants from "./dependantsReducer";
import httpIntercept from "./httpInterceptReducer";
import {
  libraryCatalogueItems,
  libraryItem,
  libraryCatalogueFilter,
} from "./libraryCatalogueReducer";
import login from "./loginReducer";
import sso from "./ssoReducer";
import needHelpArticle from "./needHelpArticleReducer";
import needhelp from "./needhelpReducer";
import changePassword from "./changePasswordReducer";
import forgotPassword from "./forgotPasswordReducer";
import passwordReset from "./passwordResetReducer";
import riskmedical from "./riskmedicalReducer";
import basicScreeningResults from "./basicScreeningResultsReducer";
import advancedScreeningResults from "./advancedScreeningResultsReducer";
import userProfile from "./userProfileReducer";
import dashboard from "./dashboardReducer";
import dashboardPP from "./dashboardReducerPP";
import claims from "./claimsReducer";
import claimsPP from "./claimsReducerPP";
import toast from "./toastReducer";
import hraInputQuestionnaire from "./hraInputQuestionnaireReducer";
import cart from "./cartReducer";
import hdf from "./hdfReducer";
import modal from "./modalReducer";
import notification from "./notificationReducer";
import common from "./commonReducer";
import wellnessLaunchpad from "./wellnessLaunchpadReducer";
import mentalWellness from "./mentalWellnessReducer";
import localization from "./localizationReducer";
import {
  shopActivityDetails,
  shopActivities,
  signedUpActivities,
  shopActivity,
} from "./shopActivitiesReducer";
import { hraResult, hraResultDetail, wellnessPriorities } from "./hraResultReducer";
import faceAgeing from "./faceAgeingReducer";
import contact from "./contactReducer";
import { systemMessage } from "./systemMessageReducers";
import delegation from "./delegationReducer";
import messaging from "./messagingReducer";

import { CLIENT_SETTINGS_SUCCESS } from "../actions/commonActions";

import trs from "../components/employee/benefits/trs/reducer";
import popup from "./popupReducer";
import marketplace from "./marketplaceReducer";
import carousel from "./carouselReducer";
import checkout from "./checkoutReducer";
import enrollment from "./enrollmentReducer";
import otherBenefits from "./otherBenefitsReducer";
import claimAccounts from "./claimAccountsReducer";
import newsletters from "./newslettersReducer";
import genHDF from "../components/employee/gen-hdf-form/reducer";
/**
 * Strips companyId from qualifier suffixes to get actual companyId
 * Qualifier format: -dev, -test, appended by wildcard suffixes
 * Examples, the following are valid companyId for libertyxchange
 * - libertyxchange-dev
 * - libertyxchange-dev-xxx
 * - libertyxchange-test
 * - libertyxchange-test-xxx
 * - libertyxchange-test-dev-xxx
 * @param {string} id - Id of company of which qualifier suffix to be stripped
 * @return {string} actualCompanyId - Actual Id of company
 */
const stripCompanyId = id => (id ? id.replace(/-(dev|test)(-.*)?$/, "") : "");

const rootUrls = ROOT_URL.split(",");
const routeWithoutHost = rootUrls.reduce(
  (finalRoute, currUrl) => finalRoute.replace(currUrl.trim(), ""),
  window.location.hostname
);

const routeFragments =
  routeWithoutHost.indexOf(".") > 0
    ? routeWithoutHost.split(".").filter(item => item && item !== "www")
    : null;
const companyId = routeFragments !== null && routeFragments.length > 0 ? routeFragments[0] : "";

export const getClient = () => stripCompanyId(companyId);

const appInitialState = {
  clientName: companyId,
  client: stripCompanyId(companyId), // Ideally this should be coming from API
};

const app = (state = appInitialState, action) => {
  if (action.type === FETCH_USER_SUCCESS) {
    // prioritise companyId from subdomain over clientName
    const clientName = companyId || action.payload.clientName;
    const extraData = {
      clientName,
      client: stripCompanyId(clientName),
    };
    /* evil hack here to populate client name so
      analytics can pick it up as window.CXAApollo.clientName
     */
    window.CXAApollo = {
      ...(window.CXAApollo || {}),
      ...extraData,
    };
    return action.payload.clientName
      ? {
          ...state,
          ...extraData,
        }
      : state;
  }
  return state;
};

const combineClientSettingsToCurrencyReducer = (state = appInitialState, action) => {
  const { intl: currentIntl, common } = state;
  if (currentIntl && common) {
    switch (action.type) {
      case CLIENT_SETTINGS_SUCCESS: {
        const intl = {
          ...currentIntl,
        };
        intl.formats.number.money.currency = common.clientSettings.currencyCode;
        return {
          ...state,
          intl,
        };
      }
      default:
        return state;
    }
  }
};

const appReducer = combineReducers({
  sso,
  app,
  intl,
  localization,
  form: formReducer,
  benefits,
  newuiuxBenefits,
  httpIntercept,
  libraryCatalogueItems,
  libraryItem,
  libraryCatalogueFilter,
  login,
  needHelpArticle,
  needhelp,
  changePassword,
  forgotPassword,
  passwordReset,
  riskmedical,
  checkout,
  userProfile,
  benefitsDocuments,
  benefitsSurvey,
  dashboard,
  dashboardPP,
  claims,
  claimsPP,
  cart,
  hraInputQuestionnaire,
  hdf,
  dependants,
  basicScreeningResults,
  advancedScreeningResults,
  modal,
  notification,
  toast,
  wellnessLaunchpad,
  mentalWellness,
  faceAgeing,
  common,
  hraResult,
  hraResultDetail,
  wellnessPriorities,
  contact,
  shopActivityDetails,
  shopActivities,
  signedUpActivities,
  shopActivity,
  systemMessage,
  delegation,
  messaging,
  trs,
  popup,
  carousel,
  marketplace,
  enrollment,
  otherBenefits,
  claimAccounts,
  newsletters,
  genHDF,
});

export default (state, action) => {
  // TODO: This section is messing up localization upon logout.
  if (action.type === LOGOUT_USER_REQUEST) {
    state = {
      app: state.app,
      common: state.common,
      contact: state.contact,
      localization: state.localization,
      intl: state.intl,
      toast: state.toast,
    };
  }
  const normalAppState = appReducer(state, action);
  const finalState = combineClientSettingsToCurrencyReducer(normalAppState, action);
  return finalState;
};



// WEBPACK FOOTER //
// ./reducers/index.jsx